import React, { useEffect, useState, useRef } from 'react';
import Truck_ro_recive_m_y_rep from './Truck_ro_recive_m_y_rep';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const truck_data = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/Ro/truck_ro_Received`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Truck_ro_recive_m_y_rep_dist = ({ month, year,fps_id, heading }) => {
   // console.log(month , year ,fps_id);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
  //  const [totals, setTotals] = useState([]); // State for storing column totals
    const detailsRRef = useRef(null);
 
    const handleDistClick = (month,year,fps_id ,dist_code, heading) => {
        setRenderContentt(null);
        setTimeout(() => {
            setRenderContentt(
                <Truck_ro_recive_m_y_rep month={month} year={year} fps_id={fps_id}
                 dist_code={dist_code} heading={heading} />
            );
        }, 10);
    };
    
    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await truck_data({month, year,fps_id,heading });
               // console.log(response_data +".....response_data");
                setTabHeading(response_data.heading);  
                if ( response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
                
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [month, year,fps_id,heading]);
      
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
    }, [loading, error, reportData]);


    if (loading) {
        
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }
     if (error) {
        console.log(error);
        return <div className="mainhead" align="center">Internal Error</div>;
    }
    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
     
    return (
        <> 
            <table align="center" width="80%" border={1} id="">
                <thead>
                    <tr className="tableheader">
                        <th colSpan={4 + reportData[0].comodityData.length  }>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>
                     
                            <th colSpan={reportData[0].comodityData.length} >
                            Commodity
                            </th>
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].comodityData.map((item, index) => (
                            <th key={index}>{item.comm_name_en}<br />({item.unit_type||'Kg'})</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                                <a
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() => handleDistClick(month,year,fps_id,item.dist_code,tabHeading)}
                                >
                                    {item.dist_name_en}
                                </a>
                            </td>
                            {item.comodityData.map((item1, index) => (
                                <td style={{ textAlign: 'right' }} key={index}>{item1.allot_qty.toFixed(3)}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default Truck_ro_recive_m_y_rep_dist;
